import { css } from 'styled-components'

export default function ({
  headingWrapperProps,
  imageWrapperProps,
}) {
  return {
    triangleProps: {
      clipReversed: false,
      clipDisabled: false,
    },
    wrapperProps: {
      mobileWrapperStyles: css`
        padding-top: 35px;
      `,
      tabletWrapperStyles: css`
        padding-top: 40px;
      `,
      desktopWrapperStyles: css`
        padding-bottom: 110px;
        padding-top: 50px;
      `,
    },
    containerProps: {
      mobileContainerStyles: null,
      tabletContainerStyles: null,
      desktopContainerStyles: css`
        flex-direction: row-reverse;
      `,
    },
    headingWrapperProps: {
      ...headingWrapperProps,
      mobileContainerStyles: null,
      tabletContainerStyles: null,
      desktopContainerStyles: null,
    },
    imageWrapperProps: {
      ...imageWrapperProps,
      mobileImageWrapperStyles: css`
        margin-top: 60px;
      `,
      tabletImageWrapperStyles: css`
        margin-bottom: 8px;
      `,
      desktopImageWrapperStyles: css`
        margin-bottom: 0;
        margin-top: 0;
        width: 80%;
      `,
      mobileImageStyles: css`
        position: relative;
        z-index: 100;
      `,
      tabletImageStyles: null,
      desktopImageStyles: css`        
        width: 70%;
      `,
    },
  }
}
